"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Shimmer;
var _react = _interopRequireDefault(require("react"));
var _useWindowWidth = _interopRequireDefault(require("../../../lib/useWindowWidth"));
var _styles = require("../styles");
function Shimmer() {
  const {
    aboveMd
  } = (0, _useWindowWidth.default)();
  return /*#__PURE__*/_react.default.createElement(_styles.LoadingContainer, {
    "data-testid": "Loading"
  }, /*#__PURE__*/_react.default.createElement(_styles.LoadingContent, null, /*#__PURE__*/_react.default.createElement(_styles.ContentHeader, null, /*#__PURE__*/_react.default.createElement(_styles.LoadingCell, null)), /*#__PURE__*/_react.default.createElement(_styles.ContentText, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.LoadingCell, null)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.LoadingCell, null)))), aboveMd && /*#__PURE__*/_react.default.createElement(_styles.LoadingSidebar, null, /*#__PURE__*/_react.default.createElement(_styles.SidebarProfilePic, null, /*#__PURE__*/_react.default.createElement(_styles.LoadingCell, null)), /*#__PURE__*/_react.default.createElement(_styles.SidebarInfo, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.LoadingCell, null)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.LoadingCell, null)))));
}
Shimmer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Shimmer"
};